<template>
  <div class="letterEntry__header entryFormHeader">

    <!-- 商品詳細 -->
    <div class="itemDetails">
      <div :class="['details',{'deactive_blur':!isSale}]">
        <div class="tagarea">
          <span class="badge">{{ item.service_type_str }}</span>
          <span :class="'badge u-tag-'+item.category_tag_id">{{ item.category_tag_name }}</span>
        </div>
        <div class="text">
          <span>{{ item.item_name }}</span>
        </div>
      </div>
      <div class="isNotSale" v-if="!isSale">
        <div class="isNotSale__wrapper">
          <div class="content">
            <span class="text">このセットの販売は終了いたしました</span>
            <span class="button" @click="goElement('#targetLabel')">単品での購入はこちら</span>
          </div>
        </div>
      </div>
      <div class="imageFilter">
        <img :src="this.aws_imglogic + item.item_id +'_L.png'" :class="['backgroundImage',{'deactive_blur':!isSale}]" />
      </div>
    </div>

    <!-- 商品説明 -->
    <div class="itemDescription">
      <span class="itemDescription__text">
        {{ item.detailed_explanation }}
      </span>

      <div class="expirationarea u-mg-t-1" v-if="salesEndDate">
        <div class="expirationarea__tag u-mg-r-1">
          <span>期間限定セット</span>
        </div>
        <div :class="['expirationarea__date', {'deactive': !isSale}]">
          <span>{{salesEndDate}}までの限定販売</span>
        </div>
      </div>

      <hr class="contentSeparatorSection u-mg-t-2 u-mg-b-2">

      <div :class="['pricearea',{'deactive':!isSale}]">
        <div class="pricearea__leftbox">
          <span class="text">セット割引価格</span>
        </div>
        <div class="pricearea__rightbox">
          <span class="value">¥{{ item.price_taxin | addComma }}</span>
          <span class="tax">（税込）</span>
        </div>
      </div>

      <hr class="contentSeparatorSection u-mg-t-2 u-mg-b-2">

      <div class="u-mg-t-3 u-mg-b-5 targetElement">
        <a :href="`/special/${itemsId}/profile`" :class="['btn', '-buy', { 'disabled': !isSale }]">購入へ進む</a>
      </div>

    </div>

    <!-- ラベル -->
    <div class="sectionLabel image" id="targetLabel">
      <span class="sectionLabel__text">期間限定セットに含まれる占い</span>
    </div>

    <!-- 商品リスト -->
    <div class="itemList" v-if="items">
      <app-loading :isLoading="items.length > 0 ? false : true" class="u-mg-center u-mg-t-3"></app-loading>
      <div v-for="(child,index) in items" :key="child.item_id">
        <div class="itemList__item">
          <div class="title">
            <span>{{child.item_name}}</span>
          </div>
          <div class="description">
            <span>{{child.item_description}}</span>
          </div>
          <div class="bottomarea">
            <div class="category">
              <div class="badge service_type">
                <span>{{ child.service_type_str }}</span>
              </div>
              <span :class="'badge u-tag-'+child.category_tag_id">{{child.category_tag_name}}</span>
            </div>
            <div class="price" :class="{default:!isSale}">
              <span class="text" v-if="isSale">通常価格</span>
              <span class="num">¥{{child.price_taxin}}</span>
              <span class="tax">(税込)</span>
            </div>
          </div>
          <div class="linkarea u-mg-l-1 u-mg-r-1" v-if="!isSale">
            <a :href="'/contents/'+parseDigit(child.item_id)" class="link">
              <span class="text">詳しく見る</span>
            </a>
          </div>
        </div>
        <span class="plus" v-if="!(index+1 >= items.length)"></span>
      </div>

    </div>

    <div v-if="isSale">

    <!-- 合計金額エリア -->
    <div class="totalPrice">
      <div class="totalPrice__box">
        <div class="defaultPrice">
          <div class="label">
            <span class="">通常価格合計</span>
          </div>
          <div class="price" v-if="this.itemsId==220">
            <div class="price__stringBuild">
              <span class="u-tx-size-22">¥2,400</span>
              <span class="u-tx-size-12">(税込)</span>
            </div>
          </div>
          <div class="price" v-else-if="this.itemsId==234">
            <div class="price__stringBuild">
              <span class="u-tx-size-22">¥2,400</span>
              <span class="u-tx-size-12">(税込)</span>
            </div>
          </div>
          <div class="price" v-else>
            <div class="price__stringBuild">
              <span class="u-tx-size-18">¥200</span>
              <span>×</span>
              <span class="u-tx-size-18">3</span>
              <span>=</span>
              <span class="u-tx-size-20">¥600</span>
            </div>
          </div>
        </div>

        <span class="arrow__right"></span>

        <div class="specialPrice">
          <div class="label">
            <span class="">セット割引価格</span>
          </div>
          <div class="price" v-if="this.itemsId==220">
            <span class="u-tx-bold u-tx-brand-2 u-tx-size-28">¥1,800</span>
            <span class="u-tx-bold u-tx-brand-2 u-tx-size-13">(税込)</span>
          </div>
          <div class="price" v-else-if="this.itemsId==234">
            <span class="u-tx-bold u-tx-brand-2 u-tx-size-28">¥1,200</span>
            <span class="u-tx-bold u-tx-brand-2 u-tx-size-13">(税込)</span>
          </div>
          <div class="price" v-else>
            <span class="u-tx-bold u-tx-brand-2 u-tx-size-28">¥500</span>
            <span class="u-tx-bold u-tx-brand-2 u-tx-size-13">(税込)</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="detail__sample u-mg-t-2" v-if="shortSampleText && isSampleText">
    <div class="title">
      <span>占い結果サンプル</span>
    </div>
    <div class="u-mg-t-2 summary">
      <div v-html="shortSampleText"></div>
    </div>
    <show-sample v-if="isSampleText" :items-id="itemsId" :counselor-id="counselorId" class="u-mg-t-1" ></show-sample>
  </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as type from '@/utvStore/store/mutation-types';
var initialLocation = location.origin + location.pathname;

export default {
  name: 'entry-form-header-special',
  props: {
    itemsId: { type: String, required: true },
    product: Object,
    step: { type: Number, default: 1 },
    confirm: { type: Boolean, default: false },
    isSampleText: { type: Boolean, default: false },
    counselorId: [Number, String],
    menuList: [Object, Array],
    isSale: { type: Boolean, default: false },
    currentPageNum: Number,
    optionalTagName: { type: String, default: '' },
    optionalTagId: { type: [Number, String], default: null },
    relationItemArr: [Object, Array],
    shortSampleText: { type: String, default: '' },
    salesEndDate: { type: String, default: '' }
  },
  data() {
    return {
      // 決済画面以外ではお支払い方法は表示しない
      displayPaymentMethod: location.pathname.includes('payment'),
      steps: [{ text: 'プロフィール入力' }, { text: 'お支払い' }, { text: '購入完了' }],
      isShowModal: false,
      sampleText: '',
      ga_location: initialLocation,
      aws_imglogic: 'https://s3-ap-northeast-1.amazonaws.com/uranaitv-store-imglogic/special/'
    };
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      item: state => state.item.selected,
      card: state => state.payment.card,
      counselor: state => state.counselors.counselor,
      items: state => state.item.itemData
    }),
    ...mapGetters(['isLoggedIn', 'paymentTypeStr'])
  },
  mounted() {
    this.$store.dispatch(type.SELECT_ITEM, { id: parseInt(this.itemsId, 10) });
    this.$store.dispatch(type.RESET_COUNSELORS);
    this.$store.dispatch(type.RESET_COUNSELOR);
    this.$store.dispatch(type.RESET_ITEMS);
    this.$store.dispatch(type.GET_ITEMS, { items_id: this.relationItemArr });
    if (this.counselorId) {
      this.$store.dispatch(type.GET_COUNSELOR, this.counselorId);
    }
    this.getPaymentInfo();
  },
  methods: {
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        const tokenData = { access_token: this.accessToken };
        return this.$store.dispatch(type.GET_PAYMENT_INFO, tokenData).then(this.$store.dispatch(type.GET_PAYMENT_HISTORY, tokenData));
      }
    },
    getStep() {
      if (!this.confirm || !this.card.number) {
        return this.step;
      }
      if (this.card.number) {
        return 2;
      }
    },
    openSample() {
      // GA送信
      window.gtag('event', 'SampleText', {
        page_location: initialLocation + '/sample'
      });

      this.isShowModal = true;
      this.getSampleText(this.itemsId);
    },
    getSampleText(id) {
      if (this.sampleText != null) {
        return axios.post('/api/items/getsampletext', { items_id: parseInt(this.itemsId, 10) }).then(response => {
          if (response.status === 200 && response.data.response === 'OK') {
            this.sampleText = response.data.sample_text;
          } else {
            return Promise.reject();
          }
        });
      }
    },
    setZeroNumber(num) {
      // 0埋めをして2けた数字にする
      return ('00' + num).slice(1);
    },
    goElement(target) {
      $('html,body').animate({ scrollTop: $(target).offset().top });
    },
    parseDigit(id = 0) {
      const digit = 6;
      let str = '';
      for (let i = 0; i < digit - String(id).length; i++) {
        str += '0';
      }
      str += String(id);
      return str;
    }
  }
};
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/EntryFormHeaderSpecial.vue